import React from 'react';
import toogleStore from '../urlhandler/toogleHandlerStore';
import toogleAction from '../urlhandler/toogleHandlerActions';
import { stringify } from '../helper/helperFunction';
class Title extends React.Component {
  constructor(props) {
    super(props);
    this.switchtoogle.bind(this);
  }
  switchtoogle() {
    if (this.props.dropdown === true) {
      toogleAction.dropdownToogle(this.props.field);
    } else {
      this.props.onToogle();
    }
  }
  render() {
    let defaultTitle = this.props.title !== '' ? this.props.title : 'Enter a title!';
    let defautlSubTitle = this.props.subtitle !== '' ? this.props.subtitle : '';
    const toggleClass = this.props.toogle ? 'active' : '';
    const toogleView = {
      display: this.props.selectedToogleViewType === 'true' ? 'block' : 'none',
    };
    if (defaultTitle.length > 0) {
      defaultTitle = stringify(defaultTitle);
    }
    if (defautlSubTitle !== undefined) {
      if (defautlSubTitle.length > 0) {
        defautlSubTitle = stringify(defautlSubTitle);
      }
    }
    return (<div className="title-content">
      {this.props.dropdown === true ?

      <h3 className="sidebar-title">
        <a className={toggleClass} style={toogleView} onClick= {this.switchtoogle.bind(this)}><span>{defaultTitle}</span><p className="sidebar-subtitle">{defautlSubTitle}</p></a>
      </h3>
      :
      <div>
        <h3 className="sidebar-title default">
          {defaultTitle}
          <a className={toggleClass} style={toogleView} onClick= {this.switchtoogle.bind(this)}></a>
        </h3>
        <p className="sidebar-subtitle">{defautlSubTitle}</p>
      </div>
    }

    </div>);
  }
}

Title.propTypes = {
  'title': React.PropTypes.string,
  'subtitle': React.PropTypes.string,
  'onToogle': React.PropTypes.func,
  'toogle': React.PropTypes.bool,
  'selectedToogleViewType': React.PropTypes.string,
};

export default Title;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/title.js